module.exports = __webpack_public_path__ + "resources/cf1e8982bc803e66867e0dfc7cb18282.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/hero.png
// module id = 198
// module chunks = 0